import { render, staticRenderFns } from "./ColorCheckbox.vue?vue&type=template&id=6e8777ea&scoped=true"
import script from "./ColorCheckbox.vue?vue&type=script&lang=js"
export * from "./ColorCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ColorCheckbox.vue?vue&type=style&index=0&id=6e8777ea&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8777ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e8777ea')) {
      api.createRecord('6e8777ea', component.options)
    } else {
      api.reload('6e8777ea', component.options)
    }
    module.hot.accept("./ColorCheckbox.vue?vue&type=template&id=6e8777ea&scoped=true", function () {
      api.rerender('6e8777ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/checkbox/ColorCheckbox.vue"
export default component.exports